import React, { useEffect, useState } from "react";

function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState(0); // 0 = MBCTC, 1 = UFCW 1529, 2 = Teamsters 667, 3 = IBEW 474, 4 = IBEW 1288
  const [fadeOut, setFadeOut] = useState(false);
  const UFCW1529_LOGO = "https://customer-assets.emergentagent.com/job_13e4391a-3898-46d5-8331-1b28fb5b216e/artifacts/syt0zk0e_IMG_0913.jpeg";
  const TEAMSTERS667_LOGO = "https://customer-assets.emergentagent.com/job_labor-choice/artifacts/q0v7mtys_IMG_0569.jpeg";
  const IBEW474_LOGO = "/sponsor-badges/ibew474-v2.png";
  const IBEW1288_LOGO = "/sponsor-badges/ibew1288-v2.png";

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 1150);      // MBCTC
    const t2 = setTimeout(() => setPhase(2), 2300);      // UFCW 1529
    const t3 = setTimeout(() => setPhase(3), 3450);      // Teamsters 667
    const t4 = setTimeout(() => setPhase(4), 4600);      // IBEW 474
    const t5 = setTimeout(() => setFadeOut(true), 6400); // IBEW 1288: 1.8s, then fade
    const t6 = setTimeout(() => onComplete(), 7000);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); clearTimeout(t5); clearTimeout(t6); };
  }, [onComplete]);

  const skip = () => {
    if (fadeOut) return;
    setFadeOut(true);
    setTimeout(onComplete, 350);
  };

  return (
    <div
      onClick={skip}
      data-testid="splash-screen"
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'linear-gradient(135deg, #1a0000 0%, #0d0d0d 40%, #1a0a0a 70%, #0d0d0d 100%)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        opacity: fadeOut ? 0 : 1,
        pointerEvents: fadeOut ? 'none' : 'auto',
        transition: 'opacity 0.6s ease-out',
        cursor: 'pointer',
      }}
    >
      <div style={{
        position: 'absolute', inset: 0,
        background: 'radial-gradient(ellipse at 50% 40%, rgba(245,158,11,0.18) 0%, transparent 60%)',
      }} />

      {phase === 0 ? (
        <div key="mbctc" style={{ display: 'contents' }}>
          <img
            src="/mbctc-logo.png"
            alt="Memphis Building & Construction Trades Council — First Official Sponsor"
            style={{
              maxHeight: '48vh', width: 'auto', position: 'relative', zIndex: 2,
              filter: 'drop-shadow(0 0 30px rgba(245,158,11,0.35))',
              animation: 'splashPulse 2s ease-in-out infinite, splashFadeIn 0.6s ease',
            }}
          />
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', marginTop: '14px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.55)',
              borderRadius: '999px', padding: '6px 14px', marginBottom: '14px',
            }}>
              <span style={{ color: '#fbbf24', fontSize: '11px', fontWeight: 900, letterSpacing: '2.5px', textTransform: 'uppercase' }}>★ FIRST OFFICIAL SPONSOR ★</span>
            </div>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '15px', fontWeight: 700, color: '#fff',
              margin: 0, lineHeight: 1.3, maxWidth: '480px',
            }}>
              Memphis Building & Construction<br/>Trades Council
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '11px', color: '#94a3b8',
              letterSpacing: '3.5px', textTransform: 'uppercase', marginTop: '14px',
            }}>
              Powering · Labor Education
            </p>
          </div>
          {/* The South Teaser */}
          <div style={{ position: 'relative', zIndex: 2, marginTop: '18px', display: 'flex', alignItems: 'center', gap: '10px', background: 'rgba(220,38,38,0.15)', border: '1px solid rgba(220,38,38,0.5)', borderRadius: '12px', padding: '10px 20px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{ textAlign: 'left' }}>
              <p style={{ color: '#fca5a5', fontSize: '13px', fontWeight: 900, margin: 0, letterSpacing: '1.5px' }}>
                THE <span style={{ color: '#dc2626' }}>SOUTH</span> GOT SOMETHING <span style={{ color: '#f59e0b' }}>TO SAY</span>
              </p>
              <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0, marginTop: '2px' }}>Educate · Organize · Mobilize · #LaborEducation</p>
            </div>
          </div>
        </div>
      ) : phase === 1 ? (
        <div key="ufcw1529" style={{ display: 'contents' }}>
          <img
            src={UFCW1529_LOGO}
            alt="UFCW Local 1529 — Gold Sponsor"
            style={{
              width: 'min(64vw, 340px)', height: 'auto', position: 'relative', zIndex: 2,
              borderRadius: '16px', background: '#fff', padding: '14px 18px',
              filter: 'drop-shadow(0 0 30px rgba(245,158,11,0.5))',
              animation: 'splashPulse 2s ease-in-out infinite, splashFadeIn 0.6s ease',
            }}
          />
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', marginTop: '20px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.55)',
              borderRadius: '999px', padding: '6px 14px', marginBottom: '14px',
            }}>
              <span style={{ color: '#fbbf24', fontSize: '11px', fontWeight: 900, letterSpacing: '2.5px', textTransform: 'uppercase' }}>★ GOLD SPONSOR ★</span>
            </div>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '16px', fontWeight: 700, color: '#fff',
              margin: 0, lineHeight: 1.3, maxWidth: '480px',
            }}>
              UFCW Local 1529
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '12px', color: '#fbbf24',
              marginTop: '8px', fontWeight: 700,
            }}>
              Standing strong for working families
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '11px', color: '#94a3b8',
              letterSpacing: '3.5px', textTransform: 'uppercase', marginTop: '12px',
            }}>
              Powering · Labor Education
            </p>
          </div>
        </div>
      ) : phase === 2 ? (
        <div key="teamsters667" style={{ display: 'contents' }}>
          <img
            src={TEAMSTERS667_LOGO}
            alt="Teamsters Local 667 — Gold Sponsor"
            style={{
              width: 'min(64vw, 340px)', height: 'auto', position: 'relative', zIndex: 2,
              borderRadius: '16px', background: '#fff', padding: '14px 18px',
              filter: 'drop-shadow(0 0 30px rgba(245,158,11,0.5))',
              animation: 'splashPulse 2s ease-in-out infinite, splashFadeIn 0.6s ease',
            }}
          />
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', marginTop: '20px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.55)',
              borderRadius: '999px', padding: '6px 14px', marginBottom: '14px',
            }}>
              <span style={{ color: '#fbbf24', fontSize: '11px', fontWeight: 900, letterSpacing: '2.5px', textTransform: 'uppercase' }}>★ GOLD SPONSOR ★</span>
            </div>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '16px', fontWeight: 700, color: '#fff',
              margin: 0, lineHeight: 1.3, maxWidth: '480px',
            }}>
              Teamsters Local 667
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '12px', color: '#fbbf24',
              marginTop: '8px', fontWeight: 700,
            }}>
              Memphis Strong — carrying the legacy of 1968
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '11px', color: '#94a3b8',
              letterSpacing: '3.5px', textTransform: 'uppercase', marginTop: '12px',
            }}>
              Powering · Labor Education
            </p>
          </div>
        </div>
      ) : phase === 3 ? (
        <div key="ibew474" style={{ display: 'contents' }}>
          <img
            src={IBEW474_LOGO}
            alt="IBEW Local 474 — Gold Sponsor"
            style={{
              width: 'min(64vw, 340px)', height: 'auto', position: 'relative', zIndex: 2,
              borderRadius: '16px', background: '#fff', padding: '14px 18px',
              filter: 'drop-shadow(0 0 30px rgba(245,158,11,0.5))',
              animation: 'splashPulse 2s ease-in-out infinite, splashFadeIn 0.6s ease',
            }}
          />
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', marginTop: '20px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.55)',
              borderRadius: '999px', padding: '6px 14px', marginBottom: '14px',
            }}>
              <span style={{ color: '#fbbf24', fontSize: '11px', fontWeight: 900, letterSpacing: '2.5px', textTransform: 'uppercase' }}>★ GOLD SPONSOR ★</span>
            </div>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '16px', fontWeight: 700, color: '#fff',
              margin: 0, lineHeight: 1.3, maxWidth: '480px',
            }}>
              IBEW Local 474
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '12px', color: '#fbbf24',
              marginTop: '8px', fontWeight: 700,
            }}>
              Memphis electricians — powering the Mid-South
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '11px', color: '#94a3b8',
              letterSpacing: '3.5px', textTransform: 'uppercase', marginTop: '12px',
            }}>
              Powering · Labor Education
            </p>
          </div>
        </div>
      ) : (
        <div key="ibew1288" style={{ display: 'contents' }}>
          <img
            src={IBEW1288_LOGO}
            alt="IBEW Local 1288 — Gold Sponsor"
            style={{
              width: 'min(64vw, 340px)', height: 'auto', position: 'relative', zIndex: 2,
              borderRadius: '16px', background: '#fff', padding: '14px 18px',
              filter: 'drop-shadow(0 0 30px rgba(245,158,11,0.5))',
              animation: 'splashPulse 2s ease-in-out infinite, splashFadeIn 0.6s ease',
            }}
          />
          <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', marginTop: '20px', animation: 'splashFadeIn 0.6s ease' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.55)',
              borderRadius: '999px', padding: '6px 14px', marginBottom: '14px',
            }}>
              <span style={{ color: '#fbbf24', fontSize: '11px', fontWeight: 900, letterSpacing: '2.5px', textTransform: 'uppercase' }}>★ GOLD SPONSOR ★</span>
            </div>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '16px', fontWeight: 700, color: '#fff',
              margin: 0, lineHeight: 1.3, maxWidth: '480px',
            }}>
              IBEW Local 1288
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '12px', color: '#fbbf24',
              marginTop: '8px', fontWeight: 700,
            }}>
              Memphis electrical workers — wired for the long haul
            </p>
            <p style={{
              fontFamily: 'Georgia, serif', fontSize: '11px', color: '#94a3b8',
              letterSpacing: '3.5px', textTransform: 'uppercase', marginTop: '12px',
            }}>
              Powering · Labor Education
            </p>
          </div>
        </div>
      )}

      <button
        onClick={skip}
        data-testid="splash-skip-btn"
        style={{
          position: 'absolute', bottom: '22px', left: '50%', transform: 'translateX(-50%)', zIndex: 3,
          background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.35)',
          borderRadius: '999px', color: '#fff', fontSize: '12px', fontWeight: 800,
          letterSpacing: '1.5px', padding: '9px 22px', cursor: 'pointer',
          textTransform: 'uppercase', backdropFilter: 'blur(4px)',
        }}
      >
        Tap to skip →
      </button>

      <style>{`
        @keyframes splashPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.02); }
        }
        @keyframes splashFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export { SplashScreen };
